import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "normalize.css";
import "./style.css";

const Header = ({ isLoggedIn, onLogout }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  const onLogoClick = () => {
    if (isLoggedIn) {
      navigate('/machine-management');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('username');
    setUsername('');
    onLogout();
    navigate('/login');
  };

  return (
    <nav id="top-nav" className="navbar navbar-expand mb-0 web-header">
      <div className="container-fluid">
        <button
          className="web-logo"
          onClick={isLoggedIn ? onLogoClick : null}
          title="ITRI 工業技術研究院"
          style={{ cursor: isLoggedIn ? "pointer" : "default", background: "none", border: "none" }}
        >
          <img
            src="/assets/images/logo-invert.svg"
            alt="工業技術研究院 識別標誌"
            style={{ width: '100%', height: '100%' }}
          />
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {isLoggedIn && (
              <>
                <li className="nav-item">
                  <button
                    className="nav-link text-white"
                    style={{ cursor: "default" }}
                  >
                    <i className="bi bi-person" style={{ color: "white" }}></i> {username} &ensp;
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link text-white"
                    onClick={handleLogout}
                    style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer' }}
                  >
                    <i className="bi bi-arrow-bar-right" style={{ color: "white" }}></i>
                    &ensp;登出
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;